import * as React from 'react';
import Button from '@mui/material/Button';

import { InputDialogBaseButton, InputDialogBaseDefaultButton, isLinkButton } from '../utils/DialogUtils';

interface InputInputDialogButtonProps {
    button: InputDialogBaseButton;
    value: string | number | boolean | undefined;
    valid: boolean;
    getInput: () => HTMLInputElement | undefined;
    close?: () => void;
}

export const InputDialogButton: React.FC<InputInputDialogButtonProps> = (props: InputInputDialogButtonProps) => {
    const disabled: boolean = props.button.checkInput ?
        (props.value == null || props.value === '' || !props.valid) :
        false;

    if (isLinkButton(props.button)) {
        return (
            <Button
                onClick={props.button.preventCloseCall ? undefined : props.close}
                color="primary"
                disabled={disabled}
                href={props.button.href}
                download={props.button.download}
                target="_blank"
            >
                {props.button.label}
            </Button>
        );
    }

    const clickButton: InputDialogBaseDefaultButton = props.button;

    const handleClick: () => void = () => {
        if (clickButton.callback != null) {
            const inputElement: HTMLInputElement | undefined = props.getInput();

            if (inputElement != null) {
                clickButton.callback(inputElement.value);
            } else {
                clickButton.callback('');
            }
        }

        if (props.close != null && !props.button.preventCloseCall) {
            props.close();
        }
    };

    return (
        <Button
            onClick={handleClick}
            color="primary"
            disabled={disabled}
        >
            {props.button.label}
        </Button>
    );
};